module.exports = __webpack_public_path__ + "public/images/partners/sup-8.f300174b7266fdf0e2d8eae335c0fc0a.png";